<template>
  <div>
    <div v-if="model.data.mime  === 'image/jpeg' || model.data.mime ==='image/png' || model.data.mime === 'image/gif'
    || model.data.mime === 'image/webp'">
      <b-link>
        <font-awesome-icon icon="search" @click="showImageDialog" style="color: #17a2b8"/>
      </b-link>
      <span>{{model.data.name}}</span>
    </div>
    <div v-else>{{model.data.name}}</div>
  </div>
</template>

<script>

export default {
  name: "AttachmentName",

  async created()  {
  },

  mounted(){
  },

  methods: {

    async showImageDialog(){
      await DialogManager.image(this.model.url);
    }
  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
  })

};

</script>

